import * as React from 'react';
import { useSelector } from 'react-redux';

import { BrokerButton } from '../../components/BrokerButton';
import { selectWidgetBrokerParams } from '../../selectors/brokerAvailability';
import { useNewbuildingBrokerContext } from '../NewbuildingBrokerWidgetProvider';

export interface IBrokerModalContainerProps {
  buttonText: string;
  onDealButtonClick: VoidFunction;
}

export const BrokerModalContainer: React.FC<IBrokerModalContainerProps> = ({ buttonText, onDealButtonClick }) => {
  const { openWidget } = useNewbuildingBrokerContext();

  const widgetBrokerParams = useSelector(selectWidgetBrokerParams);

  const handleDealClick = React.useCallback(() => {
    onDealButtonClick();

    if (widgetBrokerParams) {
      openWidget(widgetBrokerParams);
    }
  }, [onDealButtonClick, openWidget, widgetBrokerParams]);

  return <BrokerButton onClick={handleDealClick}>{buttonText}</BrokerButton>;
};
